<script setup lang="ts">
import { computed } from 'vue';
import { Descriptions, DescriptionsItem } from 'ant-design-vue';

import JsonValue from './JsonValue.vue';

interface Props {
  data: Record<string, unknown> | [] | null | undefined | object;
  size?: 'default' | 'middle' | 'small';
  bordered?: boolean;
  column?: number;
  layout?: 'horizontal' | 'vertical';
}

const properties = withDefaults(defineProps<Props>(), {
  size: 'small',
  bordered: true,
  column: 1,
  layout: 'horizontal',
});

const jsonData = computed(() => {
  if (!properties.data || typeof properties.data !== 'object') {
    return {};
  }
  return properties.data;
});

function formatLabel(key: string|number): string {
  return `${key}`
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
}
</script>

<template>
  <Descriptions
    :size="size"
    :bordered="bordered"
    :column="column"
    :layout="layout"
  >
    <DescriptionsItem
      v-for="(value, key) in jsonData"
      :key="key"
      :label="formatLabel(key)"
    >
      <JsonValue :value="value" />
    </DescriptionsItem>
  </Descriptions>
</template>
